import { isAbsoluteUrl } from './is-absolute-url';
import { extractImageNameFromWixMediaUrl } from './extract-image-name-from-wix-media-url';
export function buildOgImagePreview(url, width, height, method) {
    if (method === void 0) { method = 'fit'; }
    var urlOrName = url;
    if (!urlOrName) {
        return urlOrName;
    }
    if (isAbsoluteUrl(urlOrName)) {
        urlOrName = extractImageNameFromWixMediaUrl(urlOrName);
    }
    if (!urlOrName) {
        return urlOrName;
    }
    return "https://static.wixstatic.com/media/" + urlOrName + "/v1/" + method + "/w_" + width + ",h_" + height + ",al_c/" + urlOrName;
}
